import { submissionApi } from 'services/apis';
import SubmissionCardList from 'components/features/submission-card-list';
import Category from 'components/ui/category';
import { SubmissionResponseDtoStatusEnum } from 'libs/pinnacle-sdk';
import { useQuery } from 'react-query';
import HomeLayout from 'layouts/home-layout';

const submissionCategories = [
  {
    id: 1,
    title: SubmissionResponseDtoStatusEnum.Prospect,
    primaryColor: '#DBF6FE',
    secondaryColor: '#16ABDB',
  },
  {
    id: 2,
    title: SubmissionResponseDtoStatusEnum.Pending,
    primaryColor: '#FEF0D8',
    secondaryColor: '#E48F00',
  },
  {
    id: 3,
    title: SubmissionResponseDtoStatusEnum.Quoted,
    primaryColor: '#EEDEFE',
    secondaryColor: '#8F37F5',
  },
  {
    id: 4,
    title: SubmissionResponseDtoStatusEnum.Complete,
    primaryColor: '#D6EBDD',
    secondaryColor: '#329B57',
  },
];

function OldDashboard() {
  const { data: submissionStats } = useQuery('submissionStats', () =>
    submissionApi.filterSubmissionStats({
      filterSubmissionStatsQueryDto: submissionCategories.map((category) => ({
        status: category.title,
      })),
    })
  );

  return (
    <HomeLayout title="Underwriter Dashboard" allowBack={false}>
      <div className="bg-[#E3F2FB] p-[10px] rounded-lg my-[20px]">
        <div className="bg-white rounded-lg relative max-h-[80vh] overflow-hidden">
          <div className="grid pt-[10px] px-[10px] grid-cols-4 gap-[12px]">
            {submissionCategories.map((category, index) => (
              <div key={category.id}>
                <Category
                  {...category}
                  quantity={submissionStats?.[index]?.total || 0}
                />
              </div>
            ))}
          </div>
          <div className="grid p-[10px] grid-cols-4 gap-[12px] overflow-y-auto">
            {submissionCategories.map((category) => (
              <SubmissionCardList key={category.id} category={category.title} />
            ))}
          </div>
          <div className="w-full h-[69px] rounded-b-lg absolute !m-[0] bottom-[0px] [background:linear-gradient(180deg,_rgba(255,_255,_255,_0),_#fff)] z-[1]" />
        </div>
      </div>
    </HomeLayout>
  );
}

export default OldDashboard;
